export default "__VITE_ASSET__BhMKqkMd__"